import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TSelectableBillingTargets } from './types';

export function useBillingSelectableTargets(quoteId: string | null) {
  const { data, error, isLoading, mutate } = useSWR<TSelectableBillingTargets>(
    quoteId
      ? `commenda-billing/quotes/${quoteId}/billing/selectable-targets`
      : null,
    SWRFetcher({ method: 'GET' })
  );

  return { targets: data ?? null, error, isLoading, mutate };
}
